<template>
  <div class="fe-fullscreen">
    <!-- TOOLBAR TOPO -->
    <div class="fe-toolbar">
      <div class="fe-toolbar-left">
        <button class="fe-tb-back" @click="voltar"><fa-icon icon="arrow-left" /></button>
        <div class="fe-tb-title">
          <input
            type="text"
            v-model="titulo"
            placeholder="Nome da fórmula"
            class="fe-tb-name"
          />
        </div>
      </div>
      <div class="fe-toolbar-center">
        <div class="fe-tb-tabs">
          <button
            class="fe-tab-btn"
            :class="{ 'fe-tab-active': abaAtiva === 'formula' }"
            @click="abaAtiva = 'formula'"
          >
            <fa-icon icon="code" /> Fórmula
          </button>
          <button
            class="fe-tab-btn"
            :class="{ 'fe-tab-active': abaAtiva === 'regras' }"
            @click="abaAtiva = 'regras'"
          >
            <fa-icon icon="filter" /> Regras
            <span v-if="regras.length" class="fe-tab-badge">{{ regras.length }}</span>
          </button>
        </div>
      </div>
      <div class="fe-toolbar-right">
        <button v-if="temAlteracoes" class="fe-tb-btn fe-tb-reverter" @click="reverterFormula" :disabled="saving" title="Reverter para versão salva">
          <fa-icon icon="sync-alt" /> Reverter
        </button>
        <TutorialFormula ref="tutorialFormula" class="fe-tutorial-hidden" />
        <button class="fe-tb-btn fe-tb-salvar" @click="salvarFormula" :disabled="saving">
          <fa-icon :icon="saving ? 'spinner' : 'save'" :spin="saving" />
          {{ saving ? 'Salvando...' : 'Salvar' }}
        </button>
        <div class="fe-actions-wrap">
          <button class="fe-tb-btn fe-tb-actions" @click="showActionsMenu = !showActionsMenu">
            <fa-icon icon="cogs" />
          </button>
          <div v-if="showActionsMenu" class="fe-actions-menu" @mouseleave="showActionsMenu = false">
            <div class="fe-actions-section">
              <span class="fe-actions-label">Sistemas</span>
              <button class="fe-action-item" @click="acessacall = acessacall ? 0 : 1">
                <span class="fe-sys-dot-sm" :class="{ 'fe-sys-dot-on': acessacall }"></span>
                {{ nomeSistema('acessacall') }}
              </button>
              <button class="fe-action-item" @click="acessafv = acessafv ? 0 : 1">
                <span class="fe-sys-dot-sm" :class="{ 'fe-sys-dot-on': acessafv }"></span>
                {{ nomeSistema('acessafv') }}
              </button>
            </div>
            <div class="fe-actions-divider"></div>
            <button v-if="formulaId && !ativa" class="fe-action-item fe-action-success" @click="ativarFormula(); showActionsMenu = false" :disabled="saving">
              <fa-icon icon="check-circle" /> Ativar fórmula
            </button>
            <button v-if="formulaId && ativa" class="fe-action-item fe-action-warning" @click="desativarFormula(); showActionsMenu = false" :disabled="saving">
              <fa-icon icon="eye-slash" /> Desativar fórmula
            </button>
            <div class="fe-actions-divider"></div>
            <button class="fe-action-item" @click="$refs.tutorialFormula.abrir = true; showActionsMenu = false">
              <fa-icon icon="info-circle" /> Tutorial
            </button>
            <div class="fe-actions-divider" v-if="formulaId"></div>
            <button v-if="formulaId" class="fe-action-item fe-action-danger" @click="excluirFormula(); showActionsMenu = false" :disabled="saving">
              <fa-icon icon="trash" /> Excluir fórmula
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="fe-workspace">
      <!-- PAINEL COMPONENTES (esquerda, só na aba fórmula) -->
      <aside v-show="abaAtiva === 'formula'" class="fe-components" :class="{ 'fe-components-pulse': sidebarPulsing }">
        <PainelVariaveis
          :variaveis="variaveisFormula"
          :resultadosDisponiveis="resultadosDisponiveis"
          :variaveisMap="variaveisMap"
          :selecting="sidebarPulsing"
          @inserir="inserirVariavel"
        />
      </aside>

      <!-- CANVAS CENTRAL (fórmula) -->
      <main
        v-show="abaAtiva === 'formula'"
        class="fe-canvas"
        ref="canvasViewport"
        @wheel.prevent="onCanvasWheel"
        @mousedown="onCanvasMouseDown"
        @mousemove="onPanMove"
        @mouseup="stopPan"
        @mouseleave="stopPan"
        @dragover.prevent
        :class="{ 'fe-canvas-panning': isPanning }"
      >
        <div class="fe-canvas-grid"></div>

        <div class="fe-canvas-transform" :style="canvasTransformStyle">
        <div class="fe-canvas-content">
          <!-- Adicionar etapa no topo -->
          <div v-if="linhas.length > 0" class="fe-add-row">
            <div class="fe-add-box" @click="inserirLinhaEm(0)">
              <fa-icon icon="plus" />
            </div>
            <span>Adicionar etapa</span>
          </div>
          <div v-if="linhas.length > 0" class="fe-vertical-wire"></div>

          <!-- Rows de nodes horizontais -->
          <template v-for="(linha, index) in linhas">
            <!-- Wire vertical + botão inserir entre linhas -->
            <div v-if="index > 0" :key="'vw' + index" class="fe-between-lines">
              <div class="fe-vertical-wire"></div>
              <div class="fe-add-row fe-add-row-sm">
                <div class="fe-add-box fe-add-box-sm" @click="inserirLinhaEm(index)">
                  <fa-icon icon="plus" />
                </div>
                <span>Adicionar etapa</span>
              </div>
              <div class="fe-vertical-wire"></div>
            </div>
          <FormulaLinhaBuilder
            :key="index"
            :linha="linha"
            :index="index"
            :temErro="resultadoSimulacao && resultadoSimulacao.linhaErro === linha.ordem"
            :isFocused="linhaFocada === index"
            :valorPreview="getPreviewLinha(linha.resultado)"
            :variaveisMap="variaveisMap"
            :variaveisTipoMap="variaveisTipoMap"
            :resultadosAnteriores="getResultadosAnteriores(index)"
            :chavesVariaveis="chavesVariaveis"
            :isLastLine="index === linhas.length - 1"
            :forceDeactivate="activeLineIndex !== null && activeLineIndex !== index"
            @atualizar="atualizarLinha"
            @remover="removerLinha"
            @focus="linhaFocada = $event"
            @blur="linhaFocada = null"
            @pending="onPending($event, index)"
            ref="linhaBuilders"
          />
          </template>

          <!-- Wire vertical antes do add -->
          <div class="fe-vertical-wire" v-if="linhas.length > 0"></div>

          <!-- Add row -->
          <div class="fe-add-row">
            <div class="fe-add-box" @click="adicionarLinha">
              <fa-icon icon="plus" />
            </div>
            <span>Adicionar etapa</span>
          </div>

          <!-- Return node -->
          <div class="fe-return" v-if="linhas.length > 0">
            <div class="fe-return-wire"></div>
            <div class="fe-return-box" :class="{ 'fe-return-erro': resultadoSimulacao && resultadoSimulacao.erro }">
              <div class="fe-return-icon">
                <fa-icon :icon="resultadoSimulacao && resultadoSimulacao.erro ? 'exclamation-triangle' : 'check-circle'" />
              </div>
              <span class="fe-return-valor" v-if="resultadoSimulacao && !resultadoSimulacao.erro">
                {{ formatNum(resultadoSimulacao.resultado) }}
              </span>
              <span class="fe-return-valor fe-return-erro-text" v-else-if="resultadoSimulacao && resultadoSimulacao.erro">
                Erro na linha {{ resultadoSimulacao.linhaErro }}
              </span>
              <span class="fe-return-valor fe-return-pending" v-else>
                Aguardando...
              </span>
            </div>
          </div>
        </div>
        </div><!-- /fe-canvas-transform -->

        <!-- Zoom controls -->
        <div class="fe-zoom-controls">
          <button @click="zoomOut" title="Reduzir"><fa-icon icon="minus" /></button>
          <span class="fe-zoom-pct">{{ Math.round(zoom * 100) }}%</span>
          <button @click="zoomIn" title="Ampliar"><fa-icon icon="plus" /></button>
          <button @click="resetZoom" title="Resetar">Resetar</button>
        </div>

        <div v-if="erroSalvar" class="fe-canvas-erro">{{ erroSalvar }}</div>
      </main>

      <!-- PAINEL REGRAS (quando aba regras ativa) -->
      <main v-show="abaAtiva === 'regras'" class="fe-canvas fe-canvas-regras">
        <PainelRegras
          :regras="regras"
          :camposContexto="camposContexto"
          :variaveis="variaveis"
          @adicionar="adicionarRegra"
          @remover="removerRegra"
          @toggle-ativa="toggleRegraAtiva"
        />
      </main>

      <!-- PAINEL SIMULADOR (direita) -->
      <aside class="fe-simulator">
        <SimuladorPreview
          :variaveis="variaveisFormula"
          :valores="valoresSimulacao"
          :resultado="resultadoSimulacao"
          :resultadoFinal="resultadoFinal"
          :variaveisUsadas="variaveisUsadas"
          :variaveisMap="variaveisMap"
          @update-valor="atualizarValorSimulacao"
        />
      </aside>
    </div>
  </div>
</template>

<script>
import { get, post, put, del } from "@/helpers/apiRequest";
import { executarFormula, extrairVariaveis } from "@/helpers/formulaCalculo";
import { getDescricaoAcessoSistema } from "@/helpers/cargas";
import FormulaLinhaBuilder from "./components/FormulaLinhaBuilder.vue";
import PainelRegras from "./components/PainelRegras.vue";
import PainelVariaveis from "./components/PainelVariaveis.vue";
import SimuladorPreview from "./components/SimuladorPreview.vue";
import TutorialFormula from "./components/TutorialFormula.vue";

export default {
  name: "FormulaEditor",
  components: { FormulaLinhaBuilder, PainelRegras, PainelVariaveis, SimuladorPreview, TutorialFormula },
  data() {
    return {
      acao: this.$route.params.acao,
      formulaId: null,
      titulo: "",
      descricao: "",
      acessacall: 0,
      acessafv: 0,
      ativa: 0,
      abaAtiva: "formula",
      linhas: [{ ordem: 1, resultado: "etapa_1", descricao: "", expressao: "" }],
      regras: [],
      variaveis: [],
      valoresSimulacao: {},
      resultadoSimulacao: null,
      saving: false,
      erroSalvar: null,
      linhaFocada: null,
      sidebarPulsing: false,
      activeLineIndex: null,
      showActionsMenu: false,
      snapshot: null,
      zoom: 1,
      panX: 0,
      panY: 0,
      isPanning: false,
      panStartX: 0,
      panStartY: 0,
    };
  },
  computed: {
    canvasTransformStyle() {
      return {
        transform: `translate(${this.panX}px, ${this.panY}px) scale(${this.zoom})`,
        transformOrigin: '0 0',
        willChange: 'transform',
        transition: this.isPanning ? 'none' : 'transform 0.15s ease',
      };
    },
    resultadosDisponiveis() {
      return this.linhas.filter((l) => l.resultado).map((l) => l.resultado);
    },
    resultadoFinal() {
      if (!this.linhas.length) return "";
      return this.linhas[this.linhas.length - 1].resultado || "";
    },
    variaveisMap() {
      const map = {};
      for (const v of this.variaveisFormula) map[v.chave] = v.nome;
      for (const l of this.linhas) {
        if (l.resultado) {
          map[l.resultado] = l.resultado.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
        }
      }
      return map;
    },
    chavesVariaveis() {
      return this.variaveisFormula.map((v) => v.chave);
    },
    variaveisTipoMap() {
      const map = {};
      for (const v of this.variaveisFormula) map[v.chave] = v.tipo;
      return map;
    },
    variaveisFormula() {
      return this.variaveis.filter((v) => v.tipo !== "contexto");
    },
    camposContexto() {
      return this.variaveis.filter((v) => v.tipo === "contexto");
    },
    variaveisUsadas() {
      const todas = this.linhas.map((l) => l.expressao || "").join(" ");
      return this.variaveisFormula.filter((v) => todas.includes(v.chave)).map((v) => v.chave);
    },
    temAlteracoes() {
      if (!this.snapshot) return false;
      return JSON.stringify({ t: this.titulo, ac: this.acessacall, af: this.acessafv, l: this.linhas, r: this.regras }) !==
        JSON.stringify({ t: this.snapshot.titulo, ac: this.snapshot.acessacall, af: this.snapshot.acessafv, l: this.snapshot.linhas, r: this.snapshot.regras });
    },
  },
  watch: {
    linhas: { handler() { this.simular(); }, deep: true },
    titulo() { this.simular(); },
  },
  mounted() {
    document.querySelector('.c-main')?.classList.add('c-main--flush');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.querySelector('.c-app')?.style.setProperty('overflow', 'hidden');
    document.querySelector('.c-body')?.style.setProperty('overflow', 'hidden');
    this.carregarVariaveis().then(() => {
      const id = this.$route.query.id;
      if (id) {
        this.carregarFormula(id);
        return;
      }

      const iaData = sessionStorage.getItem("formula_ia_data");
      if (iaData) {
        sessionStorage.removeItem("formula_ia_data");
        try {
          const parsed = JSON.parse(iaData);
          this.titulo = parsed.titulo || "";
          this.descricao = parsed.descricao || "";
          this.resultadoFinal = parsed.resultado_final || "";
          this.linhas = (parsed.linhas || []).map((l) => ({
            ordem: l.ordem,
            resultado: l.resultado,
            descricao: l.descricao || "",
            expressao: l.expressao,
          }));
          this.$nextTick(() => this.simular());
        } catch { /* fallback: editor vazio */ }
      }
    });
  },
  beforeDestroy() {
    document.querySelector('.c-main')?.classList.remove('c-main--flush');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    document.querySelector('.c-app')?.style.removeProperty('overflow');
    document.querySelector('.c-body')?.style.removeProperty('overflow');
  },
  methods: {
    async carregarVariaveis() {
      try {
        const res = await get(`/admin/formulas-calculo/variaveis/${this.acao}`);
        this.variaveis = Array.isArray(res) ? res : (res.data || []);
        const v = {};
        for (const x of this.variaveis) {
          if (x.tipo !== 'contexto') v[x.chave] = x.valor_simulacao || 0;
        }
        this.valoresSimulacao = v;
      } catch (e) { console.error("Erro variaveis:", e); }
    },
    async carregarFormula(id) {
      try {
        const r = await get(`/admin/formulas-calculo/${id}`);
        const d = r.data || r;
        this.formulaId = d.id;
        this.titulo = d.titulo;
        this.descricao = d.descricao || "";
        this.acessacall = d.acessacall;
        this.acessafv = d.acessafv;
        this.ativa = d.ativa;
        const rawLinhas = Array.isArray(d.linhas) ? d.linhas : (d.linhas && d.linhas.data ? d.linhas.data : []);
        this.linhas = rawLinhas.map((l) => ({
          ordem: l.ordem, resultado: l.resultado, descricao: l.descricao || "", expressao: l.expressao,
        }));
        const rawRegras = Array.isArray(d.regras) ? d.regras : (d.regras && d.regras.data ? d.regras.data : []);
        this.regras = rawRegras.map((r) => ({
          ordem: r.ordem,
          ativa: r.ativa ?? 1,
          campo_condicao_id: r.campo_condicao_id,
          operador: r.operador || "",
          valor_comparacao: r.valor_comparacao || "",
          variavel_alvo_id: r.variavel_alvo_id,
          valor_override: r.valor_override ?? 0,
          descricao: r.descricao || "",
        }));
        this.salvarSnapshot();
      } catch (e) { console.error("Erro carregar formula:", e); }
    },
    salvarSnapshot() {
      this.snapshot = {
        titulo: this.titulo,
        acessacall: this.acessacall,
        acessafv: this.acessafv,
        linhas: JSON.parse(JSON.stringify(this.linhas)),
        regras: JSON.parse(JSON.stringify(this.regras)),
      };
    },
    reverterFormula() {
      if (!this.snapshot) return;
      this.titulo = this.snapshot.titulo;
      this.acessacall = this.snapshot.acessacall;
      this.acessafv = this.snapshot.acessafv;
      this.linhas = JSON.parse(JSON.stringify(this.snapshot.linhas));
      this.regras = JSON.parse(JSON.stringify(this.snapshot.regras));
    },
    getResultadosAnteriores(index) {
      return this.linhas.slice(0, index).filter((l) => l.resultado).map((l) => l.resultado);
    },
    proximoNomeEtapa() {
      const existentes = new Set(this.linhas.map((l) => l.resultado));
      let n = this.linhas.length + 1;
      while (existentes.has("etapa_" + n)) n++;
      return "etapa_" + n;
    },
    adicionarLinha() {
      const m = this.linhas.reduce((a, l) => Math.max(a, l.ordem), 0);
      this.linhas.push({ ordem: m + 1, resultado: this.proximoNomeEtapa(), descricao: "", expressao: "" });
    },
    inserirLinhaEm(index) {
      this.linhas.splice(index, 0, { ordem: 0, resultado: this.proximoNomeEtapa(), descricao: "", expressao: "" });
      this.renumearEtapas();
    },
    renumearEtapas() {
      this.linhas.forEach((l, j) => { l.ordem = j + 1; });
    },
    removerLinha(i) {
      this.linhas.splice(i, 1);
      this.linhas.forEach((l, j) => { l.ordem = j + 1; });
    },
    reordenarLinhas() {
      this.linhas.forEach((l, i) => { l.ordem = i + 1; });
    },
    atualizarLinha(i, campo, val) {
      if (campo === 'resultado') {
        const oldVal = this.linhas[i].resultado;
        if (oldVal && oldVal !== val && val) {
          this.renomearResultado(oldVal, val);
        }
      }
      this.$set(this.linhas[i], campo, val);
    },
    renomearResultado(oldName, newName) {
      const escaped = oldName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp('(?<![a-zA-Z0-9_])' + escaped + '(?![a-zA-Z0-9_])', 'g');
      for (let j = 0; j < this.linhas.length; j++) {
        if (this.linhas[j].expressao && this.linhas[j].expressao.includes(oldName)) {
          this.$set(this.linhas[j], 'expressao', this.linhas[j].expressao.replace(regex, newName));
        }
      }
    },
    inserirVariavel(chave) {
      if (this.sidebarPulsing && this.$refs.linhaBuilders) {
        for (const b of this.$refs.linhaBuilders) {
          if (b.activeSlot !== null) {
            b.inserirNoSlot(chave);
            this.sidebarPulsing = false;
            return;
          }
        }
      }
      if (this.linhas.length > 0) {
        const last = this.linhas.length - 1;
        const allowed = this.chavesVariaveis.includes(chave.trim()) ||
          this.getResultadosAnteriores(last).includes(chave.trim()) ||
          /^[\s()+\-*/.\d]+$/.test(chave.trim());
        if (!allowed) return;
        const e = this.linhas[last].expressao || "";
        this.$set(this.linhas[last], "expressao", e + (e ? " " : "") + chave);
      }
    },
    onDropCanvas() {
    },
    atualizarValorSimulacao(c, v) {
      this.$set(this.valoresSimulacao, c, v);
      this.simular();
    },
    getPreviewLinha(r) {
      if (!this.resultadoSimulacao || this.resultadoSimulacao.erro || !r) return null;
      const v = this.resultadoSimulacao.intermediarios[r];
      return v !== undefined ? v : null;
    },
    simular() {
      if (!this.linhas.length || !this.resultadoFinal) {
        this.resultadoSimulacao = null; return;
      }
      const ok = this.linhas.filter((l) => l.expressao && l.resultado);
      if (!ok.length) { this.resultadoSimulacao = null; return; }
      this.resultadoSimulacao = executarFormula(ok, this.valoresSimulacao, this.resultadoFinal);
    },
    formatNum(v) {
      if (v === null || v === undefined) return "—";
      return Number(v).toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 4 });
    },
    nomeSistema(campo) { return getDescricaoAcessoSistema(campo); },
    temRegraDuplicada() {
      const chaves = new Set();
      for (const r of this.regras) {
        if (!r.campo_condicao_id || !r.operador || !r.variavel_alvo_id) continue;
        const key = `${r.campo_condicao_id}|${r.operador}|${r.valor_comparacao}|${r.variavel_alvo_id}`;
        if (chaves.has(key)) return true;
        chaves.add(key);
      }
      return false;
    },
    async salvarFormula() {
      if (this.temRegraDuplicada()) {
        this.$swal({ title: 'Existem regras duplicadas. Remova as duplicatas antes de salvar.', icon: 'warning', confirmButtonText: 'Ok' });
        return;
      }
      this.saving = true; this.erroSalvar = null;
      const p = {
        titulo: this.titulo, descricao: this.descricao, acao: this.acao,
        acessacall: this.acessacall, acessafv: this.acessafv,
        resultado_final: this.resultadoFinal,
        linhas: this.linhas.filter((l) => l.expressao && l.expressao.trim() && l.resultado),
        regras: this.regras.map((r, i) => ({ ...r, ordem: i + 1 })),
      };
      try {
        const r = this.formulaId
          ? await put(`/admin/formulas-calculo/${this.formulaId}`, p)
          : await post("/admin/formulas-calculo", p);
        const saved = r.data || r;
        if (saved && saved.id) this.formulaId = saved.id;
        this.salvarSnapshot();
        this.$swal({ title: r.message || 'Salvo com sucesso!', icon: 'success', timer: 1500, showConfirmButton: false });
      } catch (e) {
        this.$swal({ title: e.message || 'Erro ao salvar', icon: 'error', confirmButtonText: 'Ok' });
      } finally { this.saving = false; }
    },
    async ativarFormula() {
      this.saving = true;
      try {
        const r = await put(`/admin/formulas-calculo/${this.formulaId}/ativar`);
        this.ativa = 1;
        this.$swal({ title: r.message || 'Fórmula ativada!', icon: 'success', timer: 1500, showConfirmButton: false });
      } catch (e) { this.$swal({ title: e.message || 'Erro', icon: 'error', confirmButtonText: 'Ok' }); } finally { this.saving = false; }
    },
    async desativarFormula() {
      this.saving = true;
      try {
        const r = await put(`/admin/formulas-calculo/${this.formulaId}/desativar`);
        this.ativa = 0;
        this.$swal({ title: r.message || 'Fórmula desativada!', icon: 'success', timer: 1500, showConfirmButton: false });
      } catch (e) { this.$swal({ title: e.message || 'Erro', icon: 'error', confirmButtonText: 'Ok' }); } finally { this.saving = false; }
    },
    async excluirFormula() {
      const result = await this.$swal({
        title: 'Excluir fórmula?',
        text: 'Esta ação não pode ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc2626',
        confirmButtonText: 'Sim, excluir',
        cancelButtonText: 'Cancelar',
      });
      if (!result.value) return;
      this.saving = true;
      try {
        await del(`/admin/formulas-calculo/${this.formulaId}`);
        this.voltar();
      } catch (e) { this.$swal({ title: e.message || 'Erro', icon: 'error', confirmButtonText: 'Ok' }); } finally { this.saving = false; }
    },
    onPending(active, lineIndex) {
      this.sidebarPulsing = active;
      this.activeLineIndex = active ? lineIndex : null;
    },
    onCanvasWheel(e) {
      const delta = e.deltaY > 0 ? -0.03 : 0.03;
      this.zoom = Math.max(0.5, Math.min(2, this.zoom + delta));
    },
    onCanvasMouseDown(e) {
      const tag = e.target.tagName.toLowerCase();
      if (tag === 'input' || tag === 'button' || tag === 'svg' || tag === 'path') return;
      const cls = e.target.className || '';
      if (typeof cls !== 'string') { this.startPan(e); return; }
      const interactive = ['flow-node-box', 'flow-token-del', 'flow-wire-btn', 'flow-num-input',
        'flow-del', 'pv-', 'fe-tb-', 'fe-add-box', 'fe-insert', 'box-add', 'box-slot'];
      if (interactive.some((c) => cls.includes(c))) return;
      if (tag === 'span' && (cls.includes('flow-node-icon') || cls.includes('eq-sign') || cls.includes('result-val'))) return;
      this.startPan(e);
    },
    startPan(e) {
      document.activeElement?.blur();
      if (this.$refs.linhaBuilders) {
        for (const b of this.$refs.linhaBuilders) b.blurResultado?.();
      }
      this.isPanning = true;
      this.panStartX = e.clientX - this.panX;
      this.panStartY = e.clientY - this.panY;
      e.preventDefault();
    },
    onPanMove(e) {
      if (!this.isPanning) return;
      this.panX = e.clientX - this.panStartX;
      this.panY = e.clientY - this.panStartY;
    },
    stopPan() { this.isPanning = false; },
    zoomIn() { this.zoom = Math.min(2, this.zoom + 0.15); },
    zoomOut() { this.zoom = Math.max(0.5, this.zoom - 0.15); },
    resetZoom() { this.zoom = 1; this.panX = 0; this.panY = 0; },
    adicionarRegra() {
      this.regras.push({
        ordem: this.regras.length + 1,
        ativa: 1,
        campo_condicao_id: "",
        operador: "",
        valor_comparacao: "",
        variavel_alvo_id: "",
        valor_override: 0,
        descricao: "",
      });
    },
    removerRegra(idx) {
      this.regras.splice(idx, 1);
    },
    toggleRegraAtiva(idx) {
      this.$set(this.regras[idx], "ativa", this.regras[idx].ativa ? 0 : 1);
    },
    voltar() { this.$router.push("/configuracoes/formulas-calculo"); },
  },
};
</script>

<style scoped>
/* EDITOR LAYOUT (integrado com menu VersoADM) */
.fe-fullscreen {
  display: flex; flex-direction: column;
  height: calc(100vh - 56px);
  overflow: hidden;
  background: #f8f9fb;
}

/* TOOLBAR */
.fe-toolbar {
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 16px; height: 52px;
  background: #fff; border-bottom: 1px solid #e5e7eb;
  flex-shrink: 0; z-index: 2; position: relative;
}
.fe-toolbar-left { display: flex; align-items: center; gap: 8px; }
.fe-toolbar-right { display: flex; align-items: center; gap: 8px; }
.fe-toolbar-center {
  position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%);
}
.fe-tb-back {
  width: 34px; height: 34px; display: flex; align-items: center; justify-content: center;
  border: 1px solid #e5e7eb; border-radius: 8px;
  background: #fff; color: #6b7280; cursor: pointer; transition: all 0.15s;
}
.fe-tb-back:hover { border-color: #6366f1; color: #6366f1; }
.fe-tb-name {
  border: none; background: transparent; font-size: 0.95rem;
  font-weight: 600; color: #1f2937; outline: none; width: 240px;
  border-bottom: 1.5px dashed #d1d5db; padding-bottom: 2px;
  transition: all 0.15s;
}
.fe-tb-name::placeholder { color: #d1d5db; }
.fe-tb-name:hover { border-bottom-color: #818cf8; }
.fe-tb-name:focus { border-bottom: 2px solid #6366f1; border-bottom-style: solid; }
.fe-tb-tabs {
  display: flex; gap: 4px; background: #f3f4f6; border-radius: 8px; padding: 3px;
}
.fe-tab-btn {
  display: flex; align-items: center; gap: 5px;
  padding: 5px 14px; border: none; border-radius: 6px;
  background: transparent; color: #6b7280; font-size: 0.78rem;
  font-weight: 600; cursor: pointer; transition: all 0.15s;
}
.fe-tab-btn:hover { color: #4f46e5; }
.fe-tab-active { background: #fff; color: #4f46e5; box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
.fe-tab-badge {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 18px; height: 18px; padding: 0 5px;
  border-radius: 9px; background: #6366f1; color: #fff;
  font-size: 0.65rem; font-weight: 700;
}
.fe-canvas-regras {
  overflow: auto !important; background: #f9fafb;
  cursor: default !important; user-select: text !important;
  align-items: stretch !important; justify-content: stretch !important;
}
.fe-tb-btn {
  display: flex; align-items: center; gap: 5px;
  padding: 6px 14px; border: none; border-radius: 8px;
  font-size: 0.78rem; font-weight: 600; cursor: pointer; transition: all 0.2s;
  white-space: nowrap;
}
.fe-actions-wrap { position: relative; }
.fe-tb-actions {
  background: #f3f4f6; color: #6b7280; width: 34px; height: 34px;
  justify-content: center; padding: 0; border-radius: 8px;
}
.fe-tb-actions:hover { background: #e5e7eb; color: #4f46e5; }
.fe-actions-menu {
  position: absolute; top: 42px; right: 0; z-index: 50;
  background: #fff; border: 1px solid #e5e7eb; border-radius: 10px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12); min-width: 220px;
  padding: 6px;
}
.fe-actions-section { padding: 4px 0; }
.fe-actions-label {
  display: block; padding: 4px 12px; font-size: 0.65rem;
  font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px;
  color: #9ca3af;
}
.fe-actions-divider { height: 1px; background: #f3f4f6; margin: 4px 0; }
.fe-action-item {
  display: flex; align-items: center; gap: 8px; width: 100%;
  padding: 8px 12px; border: none; background: none; border-radius: 6px;
  font-size: 0.8rem; color: #374151; cursor: pointer; transition: background 0.15s;
}
.fe-action-item:hover { background: #f3f4f6; }
.fe-action-success { color: #059669; }
.fe-action-success:hover { background: #ecfdf5; }
.fe-action-warning { color: #d97706; }
.fe-action-warning:hover { background: #fffbeb; }
.fe-action-danger { color: #dc2626; }
.fe-action-danger:hover { background: #fef2f2; }
.fe-sys-dot-sm {
  width: 8px; height: 8px; border-radius: 50%; background: #d1d5db;
  flex-shrink: 0; transition: background 0.2s;
}
.fe-sys-dot-on { background: #059669; box-shadow: 0 0 5px rgba(5,150,105,0.4); }
.fe-action-hint {
  margin-left: auto; font-size: 0.6rem; color: #d1d5db;
  font-style: italic; font-weight: 400;
}
.fe-tb-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.fe-tb-salvar { background: #6366f1; color: #fff; }
.fe-tb-salvar:hover:not(:disabled) { background: #4f46e5; }
.fe-tb-ativar { background: #059669; color: #fff; }
.fe-tb-ativar:hover:not(:disabled) { background: #047857; }
.fe-tb-desativar { background: #f59e0b; color: #fff; }
.fe-tb-desativar:hover:not(:disabled) { background: #d97706; }
.fe-tb-reverter { background: #fef3c7; color: #92400e; }
.fe-tb-reverter:hover:not(:disabled) { background: #fde68a; }
.fe-tb-excluir { background: #fee2e2; color: #dc2626; }
.fe-tb-excluir:hover:not(:disabled) { background: #fecaca; }

/* WORKSPACE */
.fe-workspace {
  display: flex; flex: 1; overflow: hidden;
}

/* SCROLLBAR ESTILIZADO */
.fe-components::-webkit-scrollbar, .fe-simulator::-webkit-scrollbar { width: 4px; }
.fe-components::-webkit-scrollbar-thumb, .fe-simulator::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 4px; }
.fe-components::-webkit-scrollbar-track, .fe-simulator::-webkit-scrollbar-track { background: transparent; }
.fe-components, .fe-simulator { scrollbar-width: thin; scrollbar-color: #d1d5db transparent; }

/* PAINEL COMPONENTES */
.fe-components {
  width: 220px; flex-shrink: 0;
  background: #fff; border-right: 1px solid #e5e7eb;
  padding: 14px; overflow-y: auto; overflow-x: hidden;
  transition: box-shadow 0.3s, background 0.3s, border-color 0.3s;
}
.fe-components-pulse {
  animation: sidebarGlow 1s ease-in-out infinite;
  border-right: 3px solid #10b981;
}
@keyframes sidebarGlow {
  0%, 100% {
    box-shadow: inset 0 0 0 0 rgba(16,185,129,0);
    background: #fff;
  }
  50% {
    box-shadow: inset 0 0 60px rgba(16,185,129,0.12), 6px 0 20px rgba(16,185,129,0.15);
    background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  }
}

/* CANVAS */
.fe-canvas {
  flex: 1; position: relative; overflow: hidden;
  display: flex; align-items: flex-start; justify-content: center;
  cursor: grab; user-select: none;
}
.fe-canvas input { user-select: text; }
.fe-canvas:active { cursor: grabbing; }
.fe-canvas-grid {
  position: absolute; inset: 0;
  background-image:
    radial-gradient(circle, #e0e0e0 1px, transparent 1px);
  background-size: 24px 24px;
  opacity: 0.5;
  pointer-events: none;
}
.fe-canvas-panning { cursor: grabbing; }
.fe-canvas-transform {
  min-width: 100%; min-height: 100%;
}
.fe-canvas-content {
  position: relative; z-index: 1;
  padding: 30px 24px;
  min-width: 100%;
  width: max-content;
}

/* ZOOM CONTROLS */
.fe-zoom-controls {
  position: absolute; bottom: 16px; left: 16px; z-index: 10;
  display: flex; align-items: center; gap: 4px;
  background: #fff; border: 1px solid #e5e7eb; border-radius: 10px;
  padding: 4px 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.fe-zoom-controls button {
  width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;
  border: 1px solid #e5e7eb; border-radius: 6px; background: #fff;
  color: #6b7280; cursor: pointer; font-size: 0.7rem; transition: all 0.15s;
}
.fe-zoom-controls button:hover { background: #f0f4ff; border-color: #818cf8; color: #6366f1; }
.fe-zoom-pct {
  font-size: 0.7rem; font-weight: 600; color: #374151;
  min-width: 36px; text-align: center;
}

/* BETWEEN LINES (wire + insert button) */
.fe-between-lines {
  display: flex; flex-direction: column; align-items: center;
}
.fe-add-row.fe-add-row-sm { gap: 6px; padding: 2px 0; }
.fe-add-row.fe-add-row-sm span { font-size: 0.6rem; }
.fe-add-box.fe-add-box-sm {
  width: 24px; height: 24px;
  font-size: 0.6rem;
  border-width: 1.5px;
}

/* VERTICAL WIRE ENTRE ROWS */
.fe-vertical-wire {
  width: 1.5px; height: 16px;
  background: #d1d5db;
  margin: 0 auto;
  position: relative;
}

/* ADD ROW */
.fe-add-row {
  display: flex; align-items: center; gap: 8px;
  justify-content: center;
  padding: 4px 0;
  pointer-events: none; /* row não captura eventos */
}
.fe-add-row span { font-size: 0.72rem; color: #d1d5db; pointer-events: none; }
.fe-add-box {
  width: 36px; height: 36px; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  border: 2px dashed #d1d5db; background: #fff; color: #d1d5db;
  font-size: 0.8rem; transition: all 0.2s; cursor: pointer;
  pointer-events: auto; /* só o botão captura eventos */
}
.fe-add-box:hover { border-color: #6366f1; color: #6366f1; background: #f5f3ff; }
.fe-add-box:hover + span { color: #6366f1; }

/* RETURN NODE */
.fe-return { display: flex; flex-direction: column; align-items: center; }
.fe-return-wire { width: 1.5px; height: 16px; background: #a7f3d0; }
.fe-return-box {
  display: flex; align-items: center; gap: 12px;
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  border: 1.5px solid #a7f3d0; border-radius: 12px;
  padding: 10px 20px;
}
.fe-return-icon { font-size: 1.2rem; color: #059669; }
.fe-return-erro .fe-return-icon { color: #dc2626; }
.fe-return-erro { background: linear-gradient(135deg, #fef2f2, #fee2e2) !important; border-color: #fecaca !important; }
.fe-return-valor {
  font-family: 'SF Mono', monospace; font-size: 1.3rem;
  font-weight: 800; color: #059669;
}
.fe-return-erro-text { color: #dc2626; font-size: 0.8rem; }
.fe-return-pending { color: #9ca3af; font-size: 0.8rem; font-weight: 500; }

.fe-canvas-erro {
  position: absolute; bottom: 16px; left: 50%; transform: translateX(-50%);
  background: #fef2f2; border: 1px solid #fecaca; color: #dc2626;
  padding: 8px 16px; border-radius: 10px; font-size: 0.8rem;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

/* PAINEL SIMULADOR */
.fe-simulator {
  width: 240px; flex-shrink: 0;
  background: #fff; border-left: 1px solid #e5e7eb;
  padding: 14px; overflow-y: auto;
}
</style>

<!-- CSS global para flush do container pai -->
<style>
.c-main--flush { padding: 0 !important; overflow: hidden !important; }
.c-main--flush .container-fluid { padding: 0 !important; max-width: 100% !important; overflow: hidden !important; }
.c-main--flush .c-body { overflow: hidden !important; }
.fe-tutorial-hidden .tut-btn { display: none !important; }
</style>
